import type { FireAnalyticsEvent } from '../../types';

type FailedDependency = 'search-config' | `search-3p-config` | 'outbound-auth-github' | 'search-combined-config';

type onFailedDependencyArgs = {
	dependency: FailedDependency;
	searchSessionId: string;
	source: string;
};

// Fires an event when a dependency of search page fails outside any request caching
// Note: should be fired at the application level, so this event matches impact on the UX
export const onFailedDependency = ({
	dependency,
	searchSessionId,
	source,
}: onFailedDependencyArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'failedDependency',
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				failedDependency: dependency,
				searchSessionId,
			},
		},
	};
};
